// File path: /modules/bridge/frontend/src/constants/roles.ts
// Bridge Role Constants for Access Control

// SpEd-specific roles
export const SPED_TEACHER_ROLES = ['SpEdTeacher', 'SchoolPsychologist', 'SpEdDirector', 'SchoolAdmin', 'DistrictAdmin', 'ProgramAdmin', 'StateAdmin', 'SuperAdmin'];
export const SPED_DIRECTOR_ROLES = ['SpEdDirector', 'SchoolAdmin', 'DistrictAdmin', 'ProgramAdmin', 'StateAdmin', 'SuperAdmin'];
export const SCHOOL_ADMIN_ROLES = ['SchoolAdmin', 'DistrictAdmin', 'ProgramAdmin', 'StateAdmin', 'SuperAdmin'];
export const DISTRICT_ADMIN_ROLES = ['DistrictAdmin', 'ProgramAdmin', 'StateAdmin', 'SuperAdmin'];
export const PROGRAM_ADMIN_ROLES = ['ProgramAdmin', 'StateAdmin', 'SuperAdmin'];
export const STATE_ADMIN_ROLES = ['StateAdmin', 'SuperAdmin'];
export const SUPER_ADMIN_ROLES = ['SuperAdmin'];

// All roles that can view Bridge module
export const ALL_BRIDGE_ROLES = [
  'Teacher',
  'Coach',
  'SpEdTeacher',
  'SchoolPsychologist',
  'SpEdDirector',
  'SchoolAdmin',
  'DistrictAdmin',
  'ProgramAdmin',
  'StateAdmin',
  'SuperAdmin',
];

// Roles that can manage students
export const CAN_MANAGE_STUDENTS = SPED_TEACHER_ROLES;

// Roles that can manage documents
export const CAN_MANAGE_DOCUMENTS = SPED_TEACHER_ROLES;

// Roles that can manage goals
export const CAN_MANAGE_GOALS = SPED_TEACHER_ROLES;

// Roles that can manage services/accommodations library
export const CAN_MANAGE_SERVICE_LIBRARY = SPED_DIRECTOR_ROLES;

// Roles that can assign services to students
export const CAN_ASSIGN_SERVICES = SPED_TEACHER_ROLES;

// Roles that can view compliance dashboard
export const CAN_VIEW_COMPLIANCE = SPED_DIRECTOR_ROLES;

// Roles that can view all students (vs just assigned)
export const CAN_VIEW_ALL_STUDENTS = SPED_DIRECTOR_ROLES;

// Role display names
export const ROLE_DISPLAY_NAMES: Record<string, string> = {
  Teacher: 'Teacher',
  Coach: 'Coach',
  SpEdTeacher: 'Special Education Teacher',
  SchoolPsychologist: 'School Psychologist',
  SpEdDirector: 'Special Education Director',
  SchoolAdmin: 'Principal',
  DistrictAdmin: 'District Administrator',
  ProgramAdmin: 'Program Administrator',
  StateAdmin: 'State Administrator',
  SuperAdmin: 'Super Administrator',
};
